import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H3, P, Progressbar, SVG } from "../../../../AbstractElements";

const OurContributed = () => {
  return (
    <Col xl="6" lg="12" className="proorder-xl-10 proorder-lg-11">
      <Card className="progress-show">
        <CardHeader className="card-no-border">
          <div className="d-flex">
            <div className="d-flex">
              <H3>Our Distributed</H3>
              <P>4,562,737 CIC</P>
            </div>
            <div className="d-flex">
              <H3>Our Contributed</H3>
              <P>3798 ETH 70 VTH</P>
            </div>
          </div>
        </CardHeader>
        <CardBody className="pt-0">
          <div className="progress-widget">
            <Progressbar className="sm-progress-bar progress-animate progress-gradient-primary" value={65}>
              <span className="animate-circle" />
              <span className="tool-tip">3.5 </span>
              <SVG iconId="arrow" />
            </Progressbar>
            <div className="progress-range">
              <span>$10</span>
              <span>$5M</span>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OurContributed;
